import { SpecialOffersUI } from "./SpecialOffersUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { hasSizes } from "../../utils/product/hasSizes";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";
import { removeIFCMessages } from "../../utils/product/interestFreeCredit/removeIFCMessages";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";

export function SpecialOffers({
  product,
  runtimeConfig,
  flags,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "flags" | "experiencesRawObject"
>) {
  const router = useRouter();
  const sizeParam = getSizeQuery(router.query);
  const { variant } = useVariant(product);
  const productHasSizes = hasSizes(product);
  const isVariantExplicitlySelected = productHasSizes && sizeParam;
  const messages =
    (isVariantExplicitlySelected ? variant.messaging : product.messaging) || [];

  const specialOffersVariant = flags.specialOffersVariant.value;

  const cleanedMessages = removeIFCMessages(messages);

  const { brand } = product;
  const isBlackOverride = isDiorBrand(brand?.name);

  const prodCatEndpoint = runtimeConfig.prodcatEndpoint;
  const prodCatApiKey = runtimeConfig.prodcatApiKey;
  const basketEndpoint = runtimeConfig.basketApiBaseUrl;

  const applyNewDrawerUI =
    experiencesRawObject.find(
      ({ parameters }) =>
        parameters?.["pdp-scaffold-apply-new-drawer-ui"] !== undefined,
    )?.parameters?.["pdp-scaffold-apply-new-drawer-ui"] ?? false;

  return (
    <SpecialOffersUI
      messages={cleanedMessages}
      isBlackOverride={isBlackOverride}
      prodCatEndpoint={prodCatEndpoint}
      prodCatApiKey={prodCatApiKey}
      basketEndpoint={basketEndpoint}
      specialOffersVariant={
        specialOffersVariant ? specialOffersVariant.toString() : undefined
      }
      runtimeConfig={runtimeConfig}
      experiencesRawObject={experiencesRawObject}
      applyNewDrawerUI={applyNewDrawerUI}
    />
  );
}
